module.exports = __webpack_public_path__ + "static/media/23.fde1fc42.mp3";